{
  "label": "label",
  "name": "nome",
  "gamme": "gamma",
  "serialNumber": "Numero di serie",
  "firmwareVersion": "Versione software",
  "status": "Stato",
  "sector": "Rete",
  "certificate": "Certificato",
  "connectivity": "Connettività",
  "applicationDate": "Application date",
  "date": "Data",
  "startDate": "Data di inizio",
  "endDate": "Data di fine",
  "id": "Id",
  "search": "Ricerca"
}
